import { PermissionSlug, FeatureFlag } from '../constants/featureFlags';
import { useStore } from '../store';
import { selectIsRogerEmrEnabled } from '../store/slices/authSlice';

// The one advanced-reporting gate shared by the report builder and the
// dashboard tab bar.
export function useAdvancedReportingEnabled(): boolean {
  // This live product selector is the outer boundary for advanced reporting;
  // rollout flags and dataset permissions cannot grant it to Docs-only agencies.
  const isRogerEmrEnabled = useStore(selectIsRogerEmrEnabled);
  const hasAdvancedDatasetPermission = useStore(state =>
    state.hasAnyPermission([
      PermissionSlug.REPORTS_VISITS,
      PermissionSlug.REPORTS_EPISODES,
      PermissionSlug.REPORTS_PATIENTS,
      PermissionSlug.REPORTS_CLAIMS,
      PermissionSlug.REPORTS_USER_LICENSES,
    ])
  );
  // Subscribe to the DERIVED boolean, not the stable hasFeatureFlag fn: the fn
  // ref never changes when feature_flags change, so a mid-session flag grant
  // (org rollout while the tab stays open) must re-render — and re-run the load
  // effect — through the boolean flipping, not a new fn identity.
  const advancedReporting = useStore(state =>
    state.hasFeatureFlag(FeatureFlag.ADVANCED_REPORTING, 'workos')
  );
  return isRogerEmrEnabled && advancedReporting && hasAdvancedDatasetPermission;
}
